import { GzChipsGeneratorInputWebComponent } from './component/GzChipsGeneratorInputWebComponent';

export { GzChipsGeneratorInputWebComponent };
